var map = {
	"./actions-tray/feature": [
		25954,
		5954
	],
	"./assets/feature": [
		85284,
		2396,
		5284
	],
	"./batching/feature": [
		66364,
		9423,
		2396,
		1198,
		262,
		836,
		7012,
		6609,
		477,
		1800,
		656,
		1238,
		4054,
		3943
	],
	"./counterfactual/feature": [
		46528,
		2396,
		1798,
		9423,
		7618,
		7909,
		8174,
		7012,
		2677,
		6790,
		477,
		1800,
		8830,
		8321,
		898,
		617,
		8201,
		493,
		6528
	],
	"./global-search/feature": [
		97802,
		8043,
		2396,
		4724,
		5988,
		5753
	],
	"./gtf/feature": [
		30582,
		3230,
		582
	],
	"./hypernative/feature": [
		59275,
		9596,
		8321,
		8477
	],
	"./ledger/feature": [
		61681,
		2396,
		1681
	],
	"./myAccounts/feature": [
		74968,
		2396,
		8043,
		5702,
		4724,
		2874,
		3916
	],
	"./nfts/feature": [
		35369,
		6660,
		2396,
		9484,
		3265,
		5369
	],
	"./no-fee-campaign/feature": [
		41065,
		262,
		1065
	],
	"./oidc-auth/feature": [
		67990,
		2396,
		7990
	],
	"./portfolio/feature": [
		92050,
		5815,
		2050
	],
	"./recovery/feature": [
		61857,
		262,
		2396,
		1198,
		836,
		9423,
		7618,
		7012,
		6609,
		2677,
		6790,
		7848,
		477,
		1800,
		656,
		1238,
		4054,
		8830,
		8515,
		2429,
		8224,
		2670,
		1712
	],
	"./security/feature": [
		65818,
		2677,
		8802,
		5818
	],
	"./spaces/feature": [
		2118,
		6835,
		2396,
		8043,
		216,
		836,
		1198,
		262,
		9423,
		7012,
		6609,
		2677,
		5420,
		5909,
		8946,
		477,
		1800,
		656,
		1238,
		4054,
		4724,
		8802,
		5988,
		632
	],
	"./speedup/feature": [
		77363,
		1798,
		9423,
		477,
		2939
	],
	"./spending-limits/feature": [
		25456,
		2396,
		7618,
		9423,
		1198,
		262,
		836,
		8174,
		1798,
		317,
		7012,
		6609,
		2677,
		6790,
		7848,
		2206,
		6033,
		5420,
		477,
		1800,
		656,
		1238,
		4054,
		8830,
		8321,
		898,
		617,
		8515,
		8201,
		2429,
		8224,
		5313,
		2533,
		5456
	],
	"./stake/feature": [
		77754,
		262,
		2396,
		1198,
		836,
		9423,
		7012,
		6609,
		477,
		1800,
		656,
		1238,
		4054,
		5844
	],
	"./support-chat/feature": [
		41029,
		1029
	],
	"./swap/feature": [
		21221,
		2396,
		1041,
		4054,
		5653
	],
	"./targeted-features/feature": [
		52814,
		2814
	],
	"./targeted-outreach/feature": [
		31429,
		3790,
		1429
	],
	"./transactions/feature": [
		50374,
		836,
		2396,
		1198,
		262,
		9423,
		7012,
		6609,
		477,
		1800,
		656,
		1238,
		4054,
		2670,
		8216
	],
	"./tx-notes/feature": [
		73322,
		3322
	],
	"./wallet/feature": [
		71993,
		4872,
		1993
	],
	"./walletconnect/feature": [
		4390,
		1520,
		262,
		7012,
		6609,
		6847,
		8048,
		4390
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73061;
module.exports = webpackAsyncContext;